/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type UserRole = typeof UserRole[keyof typeof UserRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRole = {
  SUPERADMIN: 'SUPERADMIN',
  OWNER: 'OWNER',
  MEMBER: 'MEMBER',
  GUEST: 'GUEST',
} as const;
